const NL_COMPACT_POSTAL_CODE = /^(\d{4})\s*([A-Z]{2})$/i;

/**
 * WHO-5453 round 2 (F12). Display formatting for postal codes. Dutch codes are
 * written "1234 AB"; stored values often arrive as "1234ab". Only the rendered
 * text changes, the stored value and what is sent to the API stay as they are.
 * Other countries are returned unchanged.
 */
export const formatPostalCode = (
  value: string | null | undefined,
  country: string | null | undefined
) => {
  if (!value) {
    return "";
  }

  if (country?.toUpperCase() !== "NL") {
    return value;
  }

  const match = NL_COMPACT_POSTAL_CODE.exec(value.trim());

  if (!match) {
    return value;
  }

  return `${match[1]} ${match[2]?.toUpperCase()}`;
};
